<div class="application-banner px-4 py-4 bg-light border-bottom">
  <div class="container">
    <small class="text-muted mb-2 d-block">{{'jobaplication-for' | translate}}</small>
    <h4 class="fw-bold text-dark mb-1">{{jobOpeningSelected.name || jobOpeningSelected.titulo_vacante}}</h4>
    <div class="d-flex flex-wrap align-items-center gap-3 text-muted small">
      <span *ngIf="!jobOpeningSelected.ocultar_sueldo"><strong>{{getSueldo()}}</strong></span>
      <span *ngIf="!jobOpeningSelected.ocultar_sueldo" class="dot-separator">•</span>
      <span>{{getCategoria()}}</span>
      <span class="dot-separator">•</span>
      <span>{{getUbicacion()}}</span>
      <span class="dot-separator">•</span>
      <span>Publicado el {{getFechaPublicacion()}}</span>
    </div>
  </div>
</div>

<div class="postulacion-container">
    <div class="row mt-2 info-postulacion-container justify-content-center">
        <div class="col-12 col-md-7 mr-2 job-apply-card">
            <ng-container *ngIf="isLoggedIn$ | async as isLoggedIn; else notLoggedIn">
                <div class="card w-100 w-lg-50 mx-auto">
                  <div
                    class="alert shadow-lg rounded-4 border-0 p-3 p-md-4 processing-card d-flex align-items-center gap-3"
                    role="alert"
                    *ngIf="mensajePostulacion === ''"
                    aria-live="polite"
                  >
                    <div class="status-icon d-flex align-items-center justify-content-center">
                      <i class="bi bi-hourglass-split"></i>
                    </div>

                    <div class="flex-grow-1">
                      <h5 class="mb-1 fw-semibold">Procesando tu postulación…</h5>
                      <p class="mb-2 text-secondary mb-3">
                        Estamos enviando tu información. Esto podría tomar unos segundos.
                      </p>

                      <div class="progress" role="progressbar" aria-label="Progreso de envío" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 75%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="card border-0 shadow-sm rounded-4 p-4 bg-light-success mb-4 text-center" *ngIf="!isError && mensajePostulacion != ''">
                    <div class="mb-3">
                      <i class="bi bi-check-circle-fill text-success" style="font-size: 2rem;"></i>
                    </div>
                    <!--h5 class="fw-bold text-success mb-2">¡Tu postulación fue exitosa!</h5-->
                    <h5 class="fw-bold text-success mb-2">{{mensajePostulacion}}</h5>

                    <p class="text-muted mb-4">Gracias por postularte a la vacante <strong class="text-primary">{{jobOpeningSelected.name || jobOpeningSelected.titulo_vacante}}</strong> en <strong class="text-primary">Manpower</strong>.  
                    Nuestro equipo revisará tu información y se pondrá en contacto contigo en caso de avanzar al siguiente paso.</p>
                    <div class="d-flex justify-content-center gap-3 flex-wrap">
                      <a routerLink="/" class="btn btn-outline-primary">Ir al inicio</a>
                      <!-- <a routerLink="/buscador" class="btn btn-outline-secondary">Ver más vacantes</a> -->
                      <!--a routerLink="/candidato-perfil" class="btn btn-outline-dark">Ver mi perfil</a-->
                    </div>
                  </div>
                  <div class="card border-0 shadow-sm rounded-4 p-4 bg-light-danger mb-4 text-center" *ngIf="isError && mensajePostulacion != ''">
                    <div class="mb-3">
                        <i class="bi bi-x-circle-fill text-danger" style="font-size: 2rem;"></i>
                    </div>
                    <h5 class="fw-bold text-danger mb-2">Error en la postulación</h5>
                    <p class="text-muted mb-4">{{mensajePostulacion}}</p>
                  </div>
                </div>
                <!-- <app-registro-corto [esRegistro]="false" [vacante]='jobOpeningSelected'></app-registro-corto> -->
            </ng-container>

            <ng-template #notLoggedIn>
                <app-login [isJobApply]="true"></app-login>
            </ng-template>
        </div>

        <div class="col-12 col-md-4 d-none d-lg-block detail-info-card">
            <!-- Detalles de la vacante -->
            <div class="card border-0 shadow-sm rounded-4 p-4 mb-4">
              <h5 class="fw-bold mb-3">{{'jobopening-detail' |translate}}</h5>

              <ul class="list-unstyled text-muted mb-4 small">
                <li class="mb-2"><i class="bi bi-clock me-2"></i> {{getTipoContratacion()}}</li>
                <li class="mb-2"><i class="bi bi-building me-2"></i> {{getLugarTrabajo()}}</li>
                <li class="mb-2"><i class="bi bi-briefcase-fill me-2"></i> {{getHorarioTrabajo()}}</li>
                <li class="mb-2"><i class="bi bi-mortarboard me-2"></i> {{getEscolaridad()}}</li>
                <li class="mb-2" *ngIf="jobOpeningSelected.experiencia"><i class="bi bi-person-check me-2"></i> Experiencia: {{jobOpeningSelected.experiencia}}</li>
                <li class="mb-2" *ngIf="getIdiomas()"><i class="bi bi-translate me-2"></i> {{getIdiomas()}}</li>
              </ul>

              <h6 class="fw-semibold text-dark mb-1">{{'description' |translate}}</h6>
              <p class="text-muted small mb-4">{{jobOpeningSelected.description || jobOpeningSelected.descripcion}}</p>

              <div *ngIf="jobOpeningSelected.beneficios">
                <h6 class="fw-semibold text-dark mb-1">{{'benefits' |translate}}</h6>
                <p class="text-muted small mb-4">{{jobOpeningSelected.beneficios}}</p>
              </div>

              <div *ngIf="jobOpeningSelected.obligatorias">
                <h6 class="fw-semibold text-dark mb-1">Competencias Obligatorias</h6>
                <p class="text-muted small mb-4">{{jobOpeningSelected.obligatorias}}</p>
              </div>

              <div *ngIf="jobOpeningSelected.opcionales">
                <h6 class="fw-semibold text-dark mb-1">Competencias Opcionales</h6>
                <p class="text-muted small mb-4">{{jobOpeningSelected.opcionales}}</p>
              </div>

              <div *ngIf="jobOpeningSelected.deseables">
                <h6 class="fw-semibold text-dark mb-1">Competencias Deseables</h6>
                <p class="text-muted small mb-4">{{jobOpeningSelected.deseables}}</p>
              </div>
            </div>

            <!-- Tarjeta de empresa -->
            <div class="card border-0 shadow-sm rounded-4 p-4">
              <div class="d-flex align-items-center mb-3">
                <img src="/assets/img/home/Manpower/mp logo.png" alt="Logo Manpower" height="32" class="me-2">
                <div>
                  <h6 class="fw-bold mb-0">Manpower</h6>
                  <small class="text-muted">{{jobOpeningSelected.destino || 'Portal de Empleo'}}</small>
                </div>
              </div>

              <ul class="list-unstyled text-muted small mb-0">
                <li><i class="bi bi-geo-alt me-2"></i> {{getUbicacion()}}</li>
                <li><i class="bi bi-briefcase me-2"></i> Puesto: {{jobOpeningSelected.name || jobOpeningSelected.titulo_vacante}}</li>
                <li *ngIf="jobOpeningSelected.categoria"><i class="bi bi-tag me-2"></i> Categoría: {{jobOpeningSelected.categoria}}</li>
                <li *ngIf="jobOpeningSelected.no_candidatos"><i class="bi bi-people me-2"></i> Vacantes: {{jobOpeningSelected.no_candidatos}}</li>
              </ul>
            </div>
        </div>
    </div>
</div>